import React, { useEffect, useState, Fragment } from 'react';
type CountdownTimerProps = {
  size?: 'compact' | 'large';
  dark?: boolean;
};
type TimeParts = {
  hours: number;
  minutes: number;
  seconds: number;
};
function getTimeParts(target: number): TimeParts {
  const remaining = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(remaining / 3600000),
    minutes: Math.floor(remaining % 3600000 / 60000),
    seconds: Math.floor(remaining % 60000 / 1000)
  };
}
export function CountdownTimer({
  size = 'compact',
  dark = false
}: CountdownTimerProps) {
  const [target] = useState(() => Date.now() + 86400000);
  const [time, setTime] = useState(() => getTimeParts(target));
  useEffect(() => {
    const interval = window.setInterval(() => setTime(getTimeParts(target)), 1000);
    return () => window.clearInterval(interval);
  }, [target]);
  const large = size === 'large';
  const valueClass = large ? 'text-5xl sm:text-7xl' : 'text-xl sm:text-2xl';
  const labelClass = large ? 'text-[10px]' : 'text-[8px]';
  return <div className="flex items-start justify-center gap-2 sm:gap-3" aria-label={`Offer ends in ${time.hours} hours, ${time.minutes} minutes and ${time.seconds} seconds`} data-id="element-21" data-mp="1bzvrm5ky66kq">
      {([[time.hours, 'hrs'], [time.minutes, 'min'], [time.seconds, 'sec']] as Array<[number, string]>).map(([value, label], index) => <Fragment key={label} data-id="element-22" data-mp="172dhibv71lb5" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={`${valueClass} font-display font-bold leading-none ${dark ? 'text-[#d4af37]' : 'text-[#0A0A0A]'}`} data-id="element-23" data-mp="1ur6bi2s99j34">
              :
            </span>}
          <div className="text-center" data-id="element-24" data-mp="1zscaujgf84lm">
            <div className={`${valueClass} font-display font-bold leading-none tabular-nums ${dark ? 'text-white' : 'text-[#0A0A0A]'}`} data-id="element-25" data-mp="1l24z0mkx5jtw">
              {String(value).padStart(2, '0')}
            </div>
            <div className={`${labelClass} mt-1 font-bold uppercase tracking-[.18em] ${dark ? 'text-[#B0B0C0]' : 'text-[#5A5A66]'}`} data-id="element-26" data-mp="2dpse5m3f7i95">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}